import gql from "graphql-tag";

export const marcarNotificacaoComoLida = gql`
    mutation marcarNotificacaoComoLida($id: ID!) {
        marcarNotificacaoComoLida(id: $id)
    }
`;
